import {weChatrequest} from '@/utils/request'
// 查询安可信设备台账列表
export function listAkxPage(data) {
  return weChatrequest({
    url: '/api/v1/registry/page',
    method: 'post',
    data
  })
}
// 新增安可信设备台账
export function addAkxPage(data) {
  return weChatrequest({
    url: '/api/v1/ankexin/device',
    method: 'post',
    data: data
  })
}

// 修改安可信设备台账
export function updateAkxPage(data) {
  return weChatrequest({
    url: `/api/v1/ankexin/device`,
    method: 'PUT',
    data: data
  })
}

// 删除安可信设备台账
export function delAkxPge(id) {
  return weChatrequest({
    url: `/api/v1/ankexin/device/${id}`,
    method: 'DELETE'
  })
}
// 导入安可信设备台账
export function importAkxPage(data) {
  return weChatrequest({
    url: '/api/v1/ankexin/device/import',
    method: 'post',
    data: data
  })
}
// 导入鑫豪斯设备台账
export function importXhsPage(data) {
  return weChatrequest({
    url: '/api/v1/xhs/device/import',
    method: 'post',
    data: data
  })
}
// 安可信设备实时数据
export function getAkxOnlineData(deviceUuid) {
  return weChatrequest({
    url: `/api/v1/ankexin/device/${deviceUuid}/online/latest`,
    method: 'get',
  })
}

//安可信设备详情(根据ID)
export function getAkxDetailData(id) {
  return weChatrequest({
    url: `/api/v1/ankexin/device/${id}`,
    method: 'get',
  })
}
// 查询压力设备台账列表
export function listYlPage(data) {
  return weChatrequest({
    url: '/api/v1/registry/page',
    method: 'post',
    data
  })
}
// 新增压力设备台账
export function addYlPage(data) {
  return weChatrequest({
    url: '/api/v1/hzxf/device',
    method: 'post',
    data: data
  })
}
//压力设备详情(根据ID)
export function getHzxfDetailData(id) {
  return weChatrequest({
    url: `/api/v1/hzxf/device/${id}`,
    method: 'get',
  })
}

// 修改压力设备台账
export function updateYlPage(data) {
  return weChatrequest({
    url: `/api/v1/hzxf/device`,
    method: 'PUT',
    data: data
  })
}

// 删除压力设备台账
export function delYlPge(id) {
  return weChatrequest({
    url: `/api/v1/hzxf/device/${id}`,
    method: 'DELETE'
  })
}
// 导入压力设备台账
export function importYlPage(data) {
  return weChatrequest({
    url: '/api/v1/hzxf/device/import',
    method: 'post',
    data: data
  })
}
// 导入希尔得设备台账
export function importXedPage(data) {
  return weChatrequest({
    url: '/api/v1/xed/device/import',
    method: 'post',
    data: data
  })
}
// 压力设备实时数据
export function getYlOnlineData(deviceId) {
  return weChatrequest({
    url: `/api/v1/hzxf/device/${deviceId}/online/latest`,
    method: 'get',
  })
}

// 查询汉威设备台账列表
export function listHwPage(data) {
  return weChatrequest({
    url: '/api/v1/registry/page',
    method: 'post',
    data
  })
}
// 新增汉威设备台账
export function addHwPage(data) {
  return weChatrequest({  // 发起微信请求
    url: '/api/v1/hanwei/device',  // 请求的API地址
    method: 'post',  // 请求方法为POST
    data: data  // 请求参数
  })
}

// 修改汉威设备台账
export function updateHwPage(data) {
  return weChatrequest({
    url: `/api/v1/hanwei/device`,
    method: 'PUT',
    data: data
  })
}
// 删除汉威设备台账
export function delHwPge(id) {
  return weChatrequest({
    url: `/api/v1/hanwei/device/${id}`,
    method: 'DELETE'
  })
}
// 汉威设备详情(根据ID)
export function getHwDetailData(id) {
  return weChatrequest({
    url: `/api/v1/hanwei/device/${id}`,
    method: 'get',
  })
}
// 新增鑫豪斯设备台账
export function addXhsPage(data) {
  return weChatrequest({ 
    url: '/api/v1/xhs/device',  
    method: 'post', 
    data: data 
  })
}

// 修改鑫豪斯设备台账
export function updateXhsPage(data) {
  return weChatrequest({
    url: `/api/v1/xhs/device`,
    method: 'PUT',
    data: data
  })
}
// 删除鑫豪斯设备台账
export function delXhsPge(id) {
  return weChatrequest({
    url: `/api/v1/xhs/device/${id}`,
    method: 'DELETE'
  })
}
// 鑫豪斯设备详情(根据ID)
export function getXhsDetailData(id) {
  return weChatrequest({
    url: `/api/v1/xhs/device/${id}`,
    method: 'get',
  })
}
// 新增希尔得设备台账
export function addXedPage(data) {
  return weChatrequest({ 
    url: '/api/v1/xed/device',  
    method: 'post', 
    data: data 
  })
}

// 修改希尔得设备台账
export function updateXedPage(data) {
  return weChatrequest({
    url: `/api/v1/xed/device`,
    method: 'PUT',
    data: data
  })
}
// 删除希尔得设备台账
export function delXedPge(id) {
  return weChatrequest({
    url: `/api/v1/xed/device/${id}`,
    method: 'DELETE'
  })
}
//希尔得设备详情(根据ID)
export function getXedDetailData(id) {
  return weChatrequest({
    url: `/api/v1/xed/device/${id}`,
    method: 'get',
  })
}
// 导入汉威设备台账
export function importHwPage(data) {
  return weChatrequest({
    url: '/api/v1/hanwei/device/import',
    method: 'post',
    data: data
  })
}
// 汉威设备实时数据
export function getHwOnlineData(deviceCode) {
  return weChatrequest({
    url: `/api/v1/hanwei/device/${deviceCode}/online/latest`,
    method: 'get',
  })
}
// 鑫豪斯设备实时数据
export function getXhsOnlineData(deviceUuid) {
  return weChatrequest({
    url: `/api/v1/xhs/device/${deviceUuid}/online/latest`,
    method: 'get',
  })
}
// 希尔得设备实时数据
export function getXedOnlineData(uuid) {
  return weChatrequest({
    url: `/api/v1/xed/device/${uuid}/realtime`,
    method: 'get',
  })
}
// 查询租户列表
export function listTenant(query) {
  return weChatrequest({
    url: '/api/v1/tenants/page',
    method: 'get',
    params: query
  })
}

// 查询租户详细

export function getTenant(id) {
  return weChatrequest({
    url: `/api/v1/tenants/${id}`,
    method: 'get'
  })
}

// 新增租户
export function addTenant(data) {
  return weChatrequest({
    url: '/api/v1/tenants',
    method: 'post',
    data: data
  })
}

// 修改租户
export function updateTenant(data) {
  return weChatrequest({
    url: `/api/v1/tenants/${data.id}`,
    method: 'PUT',
    data: data
  })
}


// 删除租户
export function delTenant(id) {
  return weChatrequest({
    url: `/api/v1/tenants/${id}`,
    method: 'DELETE'
  })
}
// 查询平台管理员管理租户权限列表
export function listPermission(query) {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants/page',
    method: 'get',
    params: query
  })
}

// 获取租户选项
export function listTenantOptions() {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants/tenants/options',
    method: 'get'
  })
}

// 获取平台管理员选项
export function listAdminOptions() {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants/admins/options',
    method: 'get'
  })
}

// 新增权限
export function addPermission(data) {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants',
    method: 'post',
    data: data
  })
}

// 修改权限
export function updatePermission(data) {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants/' + data.id,
    method: 'put',
    data: data
  })
}

// 删除权限
export function deletePermission(id) {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants/' + id,
    method: 'delete'
  })
}

// 批量删除权限
export function batchDeletePermission(adminUserId, tenantIds) {
  return weChatrequest({
    url: '/api/v1/platform-admin-tenants/batch/' + adminUserId,
    method: 'delete',
    params: { tenantIds: tenantIds }
  })
}


// 查询阀井列表
export function listWell(query) {
  return weChatrequest({
    url: '/api/valve-well/page',
    method: 'get',
    params: query
  })
}

// 新增阀井
export function addWell(data) {
  return weChatrequest({
    url: '/api/valve-well',
    method: 'post',
    data: data
  })
}

// 修改阀井
export function updateWell(data) {
  return weChatrequest({
    url: '/api/valve-well/' + data.id,
    method: 'put',
    data: data
  })
}

// 删除阀井
export function deleteWell(id) {
  return weChatrequest({
    url: '/api/valve-well/' + id,
    method: 'delete'
  })
}

// 批量删除阀井
export function batchDeleteWell(ids) {
  return weChatrequest({
    url: '/api/valve-well/batch' + ids,
    method: 'delete',
  })
}

// 根据阀井id查询使用过的执行器
export function listWellActuator(wellId) {
  return weChatrequest({
    url: `/api/actuator-well-relation/relation/${wellId}`,
    method: 'get',
  })
}

// 区域查询
export function findTree() {
  return weChatrequest({
    url: `/api/v1/sysArea/findTree`,
    method: 'get',
  })
}

// 地区修改
export function updateRegion(data) {
  return weChatrequest({
    url: `/api/v1/sysArea/edit`,
    method: 'put',
    data
  })
}


// 当前租户的菜单权限
export function getTenantMenu(tenantId) {
  return weChatrequest({
    url: `/api/v1/tenants/menu/${tenantId}`,
    method: 'get'
  })
}

// 角色数据权限
export function dataScope(data) {
  return weChatrequest({
    url: `/api/v1/tenants/menu/${data.tenantId}`,
    method: 'put',
    data: data.permKeywords
  })
}

//所有设备导出
export function exportAkxAllData(data) {
  return weChatrequest({
    url: '/api/v1/registry/export',
    method: 'post',
    data,
    responseType: "blob",
  })
}

//运行数据历史曲线
export function registryIndicator(data) {
  return weChatrequest({
    url: '/api/v1/registry/indicator',
    method: 'post',
    data: data
  })
}
//激光云台运行数据历史曲线
export function registryJgytIndicator(data) {
  return weChatrequest({
    url: `/api/v1/ankexin/laser-device/${data.id}/indicator`,
    method: 'post',
    data: data
  })
}
// 查询激光云台设备分页列表
export function listLaserDevicePage(data) {
  return weChatrequest({
    url: '/api/v1/ankexin/laser-device/page',
    method: 'post',
    data
  })
}

// 查询激光云台设备详情
export function getLaserDeviceDetail(id) {
  return weChatrequest({
    url: `/api/v1/ankexin/laser-device/${id}`,
    method: 'get'
  })
}

// 新增激光云台设备
export function addLaserDevice(data) {
  return weChatrequest({
    url: '/api/v1/ankexin/laser-device',
    method: 'post',
    data: data
  })
}

// 修改激光云台设备
export function updateLaserDevice(data) {
  return weChatrequest({
    url: '/api/v1/ankexin/laser-device',
    method: 'PUT',
    data: data
  })
}

// 删除激光云台设备
export function delLaserDevice(ids) {
  return weChatrequest({
    url: `/api/v1/ankexin/laser-device/${ids}`,
    method: 'DELETE'
  })
}

// 激光云台设备最新实时数据
export function getLaserDeviceOnlineData(deviceUuid) {
  return weChatrequest({
    url: `/api/v1/ankexin/laser-device/${deviceUuid}/online/latest`,
    method: 'get'
  })
}